/*########## Collection Filters Products #############*/
if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}

function getProducts(collection,alltags,sort){
  $.get('/collections/'+collection+'?view=filter.json'+sort, function(response) {
    response =JSON.parse(response);
    var count = 0;
    var products = response.products;
    var html='';
    var soldout='';

    products.forEach(function(product){
      if(product.available == true){
      	soldout='';
      }else{
        soldout = 'grid-view-item--sold-out product-unavailable';
      }
      var correct=true;
      var title = product.title.toLowerCase();
      if(alltags.length > 0){
        alltags.forEach(function(val){
          if($.inArray(val, product.tags) < 0){
            correct=false;
          }
        })
      }
      if(correct == true){
        count =count+1;
        html +=`<li class="grid__item medium-up--one-third custom-grid-item">
		<div class="grid-view-item product-card custom-product-card ${soldout} ${product.ptype}">`;
                      html +=`<div class="product-card__image-with-placeholder-wrapper">
              <a href="${product.url}">
              <div class="custom-product-grid-image">
              <img class="grid-view-item__image ls-is-cached lazyloaded" alt="${product.images[0].alt}" src="${product.images[0].src}">
              </div>
              </a>
              </div>`;
        html +=`<div class="product-content">`;
        html +=`<a href="${product.url}">
              <div class="h4 grid-view-item__title product-card__title">${product.title}</div>
              </a><span class="product-price"> ${product.selected_vprice}</span><span class="stamped-product-reviews-badge stamped-main-badge" data-id="${product.id}" data-product-title="${product.title}" data-product-type="${product.product_type}" style="display: block;"></span>`;
        html +=`<form method="post" action="/cart/add" id="product_form_${product.id}" accept-charset="UTF-8" class="custom_product_form" enctype="multipart/form-data" novalidate="novalidate" data-product-form=""><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">`;
        var variants='';
        var qty ='';

        html +=`<div class="product-options product-available-${product.available} ${product.hideProduct}">`;
//         if(product.variants.length == 1){
//           variants =`style="display:none"`;
//           qty =` style="width:100%"`;
//         }
        html +=`<div class="variant-list" ${variants}>
			<select name="id" id="ProductSelect-${product.id}">`;
        var variants =product.variants;
        variants.forEach(function(variant){
          html +=`<option value="${variant.id}" data-price="${variant.price}">
			${variant.title}
          </option>`;
        })
        html +=`</select>
          </div>
          <div class="quantity-update" ${qty}>
          <span class="qty_update" data-value="-1">-</span>
          <span class="item_qty ">1</span>
          <span class="qty_update" data-value="1">+</span>
          </div>
          </div> <div class="product-form__controls-group" style="display:none">
          <div class="product-form__item">
          <label for="Quantity-collection-template">Quantity</label>
          <input type="number" name="quantity" value="1" min="1" pattern="[0-9]*" class="product-form__input product-form__input--quantity" data-quantity-input="">
          </div>
          </div>`;

            html +=`<div class="product-form__controls-group product-form__controls-group--submit">
          <div class="product-form__item product-form__item--submit custom-form-submit justify-content-center">`;
        if(product.available == true){
          html +=`<button aria-label="Add to cart" class="btn product-form__cart-submit product-form__cart-submit-custom" aria-haspopup="dialog" data-col-add-to-cart-custom>
          <span data-add-to-cart-text-custom="">
          Add to cart
          </span>`;
        }
        html +=`<span class="hide" data-loader-custom>
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path></svg>
          </span>
          </button>
           <button class="btn fis-btn">
          <a data-toggle="modal" data-target="#widget-modal" data-destini-container="destinidiv" data-destini-association="default"
             data-destini-apo="${product.barcode}"
             class="findInStores">
            Find in Store</a></button>
          </div></div></form>`;
        html +=`</div></div>`;
        html +=`</li>`;
      }
    })
    if(count == 0){
      html =`<li class="grid__item"><h3 class="no-product">No Product With this Selection</h3></li>`;
    }
    $('.filters-toolbar__product-count').html(count+' Products');
    $('.custom-product-container').html(html);
    StampedFn.loadBadges();
  });
}
/*########## Collection Filters and Product Events #############*/
$(document).ready(function(){
//    $("div#widget-modal .modal-body .close").click(function(){
//     $("body").removeClass("modal-open");
//     $(".modal").removeClass("show");
//    });

  $('.coll-menu-list > .coll-menu-item').click(function(){
    window.location.href=$(this).find('a').attr('href');
  })

  $('.filter-items button').on('click', function (e) {
    if (!e.keyCode || e.keyCode === 13) {
      $('.filters-toolbar__label.select-label.FilterTags').removeClass('active').attr('aria-expanded', 'false');
      $('ul.custom-tag-filter-tags').hide();
      var sort=$('.custom_sort_by').val();
      sort='&sort_by='+sort;
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active').attr('aria-selected', 'false');
        $(this).attr('aria-pressed', 'false');
      }else{
        $(this).parent().addClass('active').attr('aria-selected', 'true');
        $(this).attr('aria-pressed', 'true');
      }
      var tag= $(this).parent().data('tag');
      var triggerButtonAriaLabelledby = ['FilterTagsLabel'];
      var coll=$(this).parent().parent().data('collection');
      var values = [];
      var count = 0;
      $('.filter-items').each(function(){
        if($(this).hasClass('active')){
          count = count + 1;
          values.push($(this).data('tag'));
          triggerButtonAriaLabelledby.push(this.id);
        }
      })
      if(count > 0){
        $('.filters-toolbar__label.select-label.FilterTags #FilterTagsLabel').text('Filter by '+count+' Allergens');
        $('.clear_filter').show();
      } else{
        $('.filters-toolbar__label.select-label.FilterTags #FilterTagsLabel').text('Filter by Allergen');
        $('.clear_filter').hide();
      }
      $('.filters-toolbar__label.select-label.FilterTags').attr('aria-labelledby', triggerButtonAriaLabelledby.join(' '))
      getProducts(coll,values,sort);
    }
    //     console.log($(this).closest('ul.custom-tag-filter-tags'));
  })

  $('.filter-items button').on('focus', function () {
    $('.filter-items').removeAttr('data-focus');
    $(this).parent().attr('data-focus', '')
  })

  $('.custom_sort_by').on('change', function() {
    var sort=$(this).val();
    sort='&sort_by='+sort;
    var coll=$(this).parent().data('collection');
    var values = [];
    $('.filter-items').each(function(){
      if($(this).hasClass('active')){
        values.push($(this).data('tag'))
      }
    })
    getProducts(coll,values,sort);
  });

  $('.clear_filter').on('click', function() {
    $('.filter-items').removeClass('active');
    $('.filter-items button').attr('aria-pressed', 'false');
    var sort=$('.custom_sort_by').val();
    sort='&sort_by='+sort;
    var coll=$(this).parent().find('.custom-tag-filter-tags').data('collection');
    var values = [];
    $('.filters-toolbar__label.select-label.FilterTags').attr('aria-labelledby', 'FilterTagsLabel')
    $('.filters-toolbar__label.select-label.FilterTags #FilterTagsLabel').text('Filter by Allergen');
    $(this).hide();
    getProducts(coll,values,sort);
  });


  $('body').on('click','.qty_update',function(e){
    e.preventDefault();
    var _form = $(this).closest('form');
    var _val = $(this).data('value');
    var _form=$(this).closest('form');
    var _update=_form.find('[name=quantity]').val();
    var _amount = parseInt(_update)+_val;
    if(_amount > 0){
      _form.find('[name=quantity]').val(_amount);
      $(this).siblings('.item_qty').html(_amount);
    }
  })


  $('body').on('click','button[data-col-add-to-cart-custom]',function(e){
    e.preventDefault();
    var _form= $(this).closest('form');
    _form.find('[data-add-to-cart-text-custom]').hide();
    _form.find('[data-loader-custom]').removeClass('hide');
    var _id=parseInt($(this).closest('form').find('[name=id]').val());
    var _qty=parseInt($(this).closest('form').find('[name=quantity]').val());
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { quantity: _qty, id:_id },
      dataType: 'json',
      success: function(data) {
        Shopify.getCart(function(cart) {
        fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          $('[data-cart-count]').html(data.item_count);
          $('[data-cart-drawer-count]').html(data.item_count);
          $('.js-cart-drawer-toggle').trigger('click');
          // if (data.item_count > 1) {
          //   $('[data-cart-drawer-label]').html('Items');
          // } else {
          //   $('[data-cart-drawer-label]').html('Item');
          // }
          if (data.item_count > 0) {
            if ($('.sdz-cart-drawer').hasClass('is-empty-cart')) {
              $('.sdz-cart-drawer').removeClass('is-empty-cart');
            };
          } else {
            $('.sdz-cart-drawer').addClass('is-empty-cart');
          }
          $('[data-cart-count-bubble]').removeClass('hide');
          _form.find('[data-loader-custom]').addClass('hide');
          _form.find('[data-add-to-cart-text-custom]').show();
        });
        }.bind(this));
      }
    });
  })


  $('.custom-tag-filter .FilterTags').on('click keydown', function(e) {
    if (!e.keyCode || e.keyCode === 13) {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active').attr('aria-expanded', 'false');
        $(this).siblings('ul.custom-tag-filter-tags').hide().removeClass('active');
      } else {
        $(this).addClass('active').attr('aria-expanded', 'true');
        $(this).siblings('ul.custom-tag-filter-tags').show().addClass('active');
        setTimeout(() => {
          $('.filter-items').first().find('button').focus();
        }, 500)
      }
    }
  })

  $('body').on('keydown', function (e) {
    const isUpArrow = e.keyCode === 38;
    const isDownArrow = e.keyCode === 40;
    const isEscape = e.keyCode === 27;
    if ($('ul.custom-tag-filter-tags').hasClass('active') && (isUpArrow || isDownArrow || isEscape)) {
      e.preventDefault();
      const $currentFocusedItem = $('.filter-items[data-focus]');
      if (isDownArrow) {
        let $nextItem = $currentFocusedItem.next();
        if (!$nextItem.length) {
          $nextItem = $('.filter-items').first();
        }
        $nextItem.find('button').focus();
      }
      if (isUpArrow) {
        let $prevItem = $currentFocusedItem.prev();
        if (!$prevItem.length) {
          $prevItem = $('.filter-items').last();
        }
        $prevItem.find('button').focus();
      }
      if (isEscape) {
        $('.filter-items').removeAttr('data-focus');
        $('.filter-items button').attr('aria-pressed', 'false');
        $('.custom-tag-filter .FilterTags').removeClass('active').attr('aria-expanded', 'false');
        $('ul.custom-tag-filter-tags').hide().removeClass('active');
      }
    }
  });

  $('ul.custom-tag-filter-tags').find('[role="button"]').last().on('keydown', function (e) {
    if (e.keyCode === 9 && !e.shiftKey) {
      $('ul.custom-tag-filter-tags').hide();
      $('.filters-toolbar__label.select-label.FilterTags').removeClass('active').attr('aria-expanded', 'false');
    }
  })

  $('.custom-product-container').on('change', 'select[name=id]', function(){
    var _price = $(this).children('option:selected').data('price');
    $(this).closest('.custom-product-card').find('span.product-price').html(_price);
  })

/*########## Article Related Products #############*/
  $('body').on('click','.rap_overlay_options .qty_update',function(e){
    e.preventDefault();
    var _val = $(this).data('value');
    var _update=$(this).siblings('.item_qty').html();
    var _amount = parseInt(_update)+_val;
    if(_amount > 0){
      $(this).siblings('.item_qty').html(_amount);
    }
  })

  $('.rap_overlay_options select[name=id]').change(function(){
    var _price= $(this).children('option:selected').data('price');
    //   console.log(_price,$(this).closest('.rap_overlay_info').find('.price'))
    $(this).closest('.rap_overlay_info').find('.price').html(_price)
  })


  $("body").on("click","button.rap_overlay_submit",function(e){
    e.preventDefault();
    var _id=parseInt($(this).closest('.rap_overlay_info').find('[name=id]').val());
    var _qty=parseInt($(this).closest('.rap_overlay_info').find('.item_qty').html());
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { quantity: _qty, id:_id },
      dataType: 'json',
      success: function(data) {
        fetch('/cart.js')
        .then(response => response.json())
        .then(data => {

          $('[data-cart-count]').html(data.item_count);
          $('.cart-drawer-toggle').trigger('click');
          $('[data-cart-count-bubble]').removeClass('hide');

        });
      }
    });
  })

})

/*########## Faq Page Tabs #############*/

$('.main_method_head').click(function(){
  var _content=$(this).data('show');
  var _image=$(this).data('image');
  $('.main_method_head').removeClass('active');
  $('.main_image').removeClass('active');
  $('.main_accordion_content').removeClass('active');
  $(this).addClass('active');
  $(_content).addClass('active');
  $(_image).addClass('active');
});


if($(window).width() > 767){
  $('.method-heading .content').click(function(){
    var _view=$(this).parent().data('show');
    $(this).closest('.main_accordion_content').find('.method-heading').removeClass('active');
    $(this).closest('.main_accordion_content').find('.method-content').removeClass('active');
    $(this).parent().addClass('active');
    $(_view).addClass('active');
  });
}
else{
  $('.method-heading .content').click(function(){
    if($(this).parent().hasClass('active')){
      $(this).closest('.main_accordion_content').find('.method-heading').removeClass('active');
      $(this).find('.main_content').slideUp(500);
    }else{
      $(this).parent().addClass('active');
      $(this).find('.main_content').slideDown(500);
    }
  });
}

/*########## Product Page Quantity Update and Add to cart #############*/


$('body').on('click','.pqty_update',function(e){
  e.preventDefault();
  var _id = $(this).siblings('.pitem_qty');
  var _update=$(this).data('value');
  var _amount = parseInt($(_id).html())+_update;
  if(_amount > 0){
    $(_id).html(_amount)
    $('input[name=quantity]').val(_amount)
  }
})


// console.log(theme.Currency.formatMoney(5000, theme.moneyFormat))

$('body').on('click','.main-variant',function(e){
  e.preventDefault();
  var _price= $(this).data('price');
  var __simple = $(this).data('simple');
  var _qty=parseInt($(this).find('.pitem_qty').html());

  $(this).closest('.product-template__container').find('span.product-price').html(_price);
  $('.main-variant').removeClass('active');
  $(this).addClass('active');
  $(this).find('[name=id]').prop('checked',true);
  var _img= $(this).data('image');
  //   $(_img).trigger('click');
  if(_qty > 1){
    var _final_price = __simple * _qty;
    $('.product-form__item--submit').find('.regular-price').html(theme.Currency.formatMoney(_final_price, theme.moneyFormat));
  }
  else{
    $('.product-form__item--submit').find('.regular-price').html(_price);
  }
})


$('.main-variants').click(function(){
  var _variant=$(this).data('variant');
  var _qty=$(_variant).find('.pitem_qty').html();
  $('.qty-desktop').find('.pitem_qty').html(_qty);
  $(_variant).trigger('click');
  $('.variant_on_mobile').html($(this).html());
  $('.main-variants').removeClass('active');
  $(this).addClass('active');
  $('.variant_on_mobile').removeClass('open');
})


$('.mobile_qty_update').on('click',function(e){
  e.preventDefault();
  var _id = $(this).siblings('.pitem_qty');
  var _update=$(this).data('value');
  var _amount = parseInt($(_id).html())+_update;
  var _main = $('.main-variant.active').find('.pitem_qty');
  var __simple = $('.main-variant.active').data('simple');
  var _price = $('.main-variant.active').data('price');
  if(_amount > 0){
    $(_id).html(_amount)
    $(_main).html(_amount)
    $('[name=quantity]').val(_amount)
    if(_amount > 1){
    var _final_price = __simple * _amount;
    $('.product-form__item--submit').find('.regular-price').html(theme.Currency.formatMoney(_final_price, theme.moneyFormat));
  }
  else{
    $('.product-form__item--submit').find('.regular-price').html(_price);
  }
  }
})


/*########## Multiple variant ATC  #############*/


function moveAlong(form,products){
  var _length=products.length;
  products.forEach(function(product,index){
    var _index = index + 1;
    var _id = product.id;
    var _qty = product.qty;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { quantity: _qty, id:_id },
      dataType: 'json',
      async:false,
      success: function(data) {
        if(_index == _length){
          fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
            $('[data-cart-count]').html(data.item_count);
          });
          form.find('[data-loader-custom]').addClass('hide');
          form.find('[data-add-to-cart-text-custom]').show();
          $('.cart-drawer-toggle').trigger('click');
          $('[data-cart-count-bubble]').removeClass('hide');
        }
      }
    });
  })
}


// $('body').on('click','[data-add-to-cart-custom]',function(e){
//   e.preventDefault();
//   var products=[];
//   var _form= $(this).closest('form');
//   $(this).closest('form').find('[data-add-to-cart-text-custom]').hide();
//   $(this).closest('form').find('[data-loader-custom]').removeClass('hide');
//   var _variants= $(this).closest('form').find('.main-variant.active');
//   var _id=_variants.find('[name=id]').val();
//   var _qty=parseInt(_variants.find('.pitem_qty').html());
// //   console.log(_id,_qty)
//   if(_qty > 0){
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: { quantity: _qty, id:_id },
//       dataType: 'json',
//       async:false,
//       success: function(data) {
//         Shopify.getCart(function(cart) {
//         //       if(_index == _length){
//         fetch('/cart.js')
//         .then(response => response.json())
//         .then(data => {
//           $('[data-cart-count]').html(data.item_count);
//         });
//         _form.find('[data-loader-custom]').addClass('hide');
//         _form.find('[data-add-to-cart-text-custom]').show();
//         $('.cart-drawer-toggle').trigger('click');
//         $('[data-cart-count-bubble]').removeClass('hide');
//         //       }
//        }.bind(this));
//       }
//     });
//   }
//   else{
//     alert('Quantity Should be Greater than 0')
//     _form.find('[data-loader-custom]').addClass('hide');
//     _form.find('[data-add-to-cart-text-custom]').show();
//   }
// //   return false;
// //   _variants.each(function(){
// //     var data=[];
// //     var _id=$(this).find('[name=id]').val();
// //     var _qty=parseInt($(this).find('.pitem_qty').html());
// //     data['id']=_id;
// //     data['qty']=_qty;
// //     products.push(data);
// //   })
// //   if(products.length > 0){
// //     moveAlong(_form,products);
// //   }
// });
$(document).on('click', 'input[data-add-to-cart-recipes]' ,function (e) {
  e.preventDefault();
  var _form= $(this).closest('form');
    _form.find('[data-add-to-cart-text-custom]').hide();
    _form.find('[data-loader-custom]').removeClass('hide');
    var _id=parseInt($(this).closest('form').find('[name=id]').val());
    var _qty=parseInt($(this).closest('form').find('[name=quantity]').val());
 console.log(_id,_qty)

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { quantity: _qty, id:_id },
      dataType: 'json',
      async:false,
      success: function(data) {
        //       if(_index == _length){
        fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          $('[data-cart-count]').html(data.item_count);
          $('[data-cart-drawer-count]').html(data.item_count);
          $('.js-cart-drawer-toggle').trigger('click');
          // if (data.item_count > 1) {
          //   $('[data-cart-drawer-label]').html('Items');
          // } else {
          //   $('[data-cart-drawer-label]').html('Item');
          // }
          if (data.item_count > 0) {
            if ($('.sdz-cart-drawer').hasClass('is-empty-cart')) {
              $('.sdz-cart-drawer').removeClass('is-empty-cart');
            };
          } else {
            $('.sdz-cart-drawer').addClass('is-empty-cart');
          }
        });
        _form.find('[data-loader-custom]').addClass('hide');
          //$('.cart-drawer-toggle').trigger('click');
        $('[data-cart-count-bubble]').removeClass('hide');
        //       }
      }
    });


});
/*########## Product Page Gallery #############*/

$(document).ready(function(){


  $(".klaviyo-close-form").addClass("close-btnn");
  $("#button2").click(function(){
    $("body").addClass("openn-popup");
  });
  $("button.klaviyo-close-form").click(function(){
    $("body").removeClass("openn-popup");
  });



  if($('body').hasClass('template-product')){
    $('.main_slider_gallery').slick({
      accessibility: false,
      arrows:false,
      slidesToShow:1,
      slidesToScroll:1,
      infinite: true,
      asNavFor:'.product-single__thumbnails'
    });

    function setTabIndex() {
      $('.js-thumbnail-btn').each(function(){
        if($(this).parent().attr('aria-hidden') === 'false'){
          $(this).attr('tabindex', '0')
        } else {
          $(this).attr('tabindex', '-1')
        }
      })
    }

    $('.product-single__thumbnails').on('init', function(event, slick){
      setTabIndex();
    });

    $('.product-single__thumbnails').slick({
      accessibility: false,
      arrows:true,
      slidesToShow:3,
      slidesToScroll:1,
      asNavFor:'.main_slider_gallery',
      infinite: true,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow:3
          }
        },
        {
          breakpoint: 620,
          settings: {
            slidesToShow:3
          }
        }
      ]
    });
    $('.product-single__thumbnails').on('afterChange', function(event, slick, currentSlide, nextSlide){
      setTabIndex();
    });


    /*########## Product Page Related Product Slider #############*/
    var recc= setInterval(function(){


      if($('.recommendations-product-list').length > 0){
        var $progressBar = $('.progress');
        var $progressBarLabel = $( '.slider__label' );

        $('.recommendations-product-list.desktop-only').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

          $progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );

          $progressBarLabel.text( calc + '% completed' );
        });


        $('.recommendations-product-list.desktop-only').slick({
          accessibility: false,
          arrows:true,
          dots:true,
          slidesToShow:6,
          slidesToScroll:1,
          responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 4
              }
            }
          ]
        });


        $('.recommendations-product-list.mobile-only').slick({
          accessibility: false,
          arrows:true,
          dots:true,
          slidesToShow:1,
          slidesToScroll:1,
        });


        clearInterval(recc);


      }
    },500)

    }
})

/*########## Faq Accordion #############*/

$('.pfaq-question').click(function(){
  if($(this).parent().hasClass('open')){
    $(this).parent().removeClass('open');
    $(this).siblings('.pfaq-answer').slideUp(800);
  }else{
    $(this).parent().addClass('open');
    $(this).siblings('.pfaq-answer').slideDown(800);
  }
})

$('.pfaq-questions').click(function(){
  if($(this).parent().hasClass('open')){
    $(this).parent().removeClass('open');
    $(this).siblings('.pfaq-answer').slideUp(800);
  }else{
    $(this).parent().addClass('open');
    $(this).siblings('.pfaq-answer').slideDown(800);
  }
})
/*########## Collection Filters Products #############*/


$('.coll-menu-select select').change(function(){
  var _href= $(this).children('option:selected').data('href');
  window.location.href=_href
})



$('.variant_on_mobile').click(function(){
  $(this).addClass('open');
})






var mouse_is_inside = false;

$(document).ready(function(){
  $('ul.custom-tag-filter-tags,.variant-list-mobile,.custom-tag-filter').hover(function(){
    mouse_is_inside=true;
  }, function(){
    mouse_is_inside=false;
  });

  $("body").mouseup(function(){
    if(!mouse_is_inside) {
      $('ul.custom-tag-filter-tags').hide();
      $('.variant_on_mobile').removeClass('open');
      $('.filters-toolbar__label.select-label.FilterTags').removeClass('active').attr('', 'false');
    }
  });
});


$('.category-title').click(function(){
  var _content = $(this).data('cat');
  $('.category-title').removeClass('active').attr('aria-selected', 'false');
  $(this).addClass('active').attr('aria-selected', 'true');
  $('.category-content').removeClass('active');
  $(_content).addClass('active');

})


/*########## Community Page Slider #############*/

var next_icon = `<button class="next_icon slick_icon">Next<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.500216 6.16668H12.6552L8.24438 1.75585L9.42271 0.577515L15.8452 7.00001L9.42271 13.4225L8.24438 12.2442L12.6552 7.83335H0.500216V6.16668Z" fill="black"/>
</svg></div>`;

var prev_icon = `<button class="prev_icon slick_icon"><svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.500216 6.16668H12.6552L8.24438 1.75585L9.42271 0.577515L15.8452 7.00001L9.42271 13.4225L8.24438 12.2442L12.6552 7.83335H0.500216V6.16668Z" fill="black"/>
</svg>Prev</div>`;

$('.cs-three-heading-content').slick({
  accessibility: false,
  arrows:true,
  dots:false,
  slidesToShow:1,
  slidesToScroll:1,
  infinite:false,
  adaptiveHeight:false,
  prevArrow: prev_icon,
  nextArrow: next_icon,
  cssEase: 'ease',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        adaptiveHeight:true
      }
    }
  ]
});


$('.chickpeas-4-heading-content').slick({
  accessibility: false,
  arrows:true,
  dots:false,
  slidesToShow:4,
  slidesToScroll:1,
  infinite:false,
  adaptiveHeight:false,
  prevArrow: prev_icon,
  nextArrow: next_icon,
  cssEase: 'ease',
  responsive: [
    {
      breakpoint: 1080,
      settings: {
        slidesToShow:3,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow:1,
      }
    }
  ]
});

$('.recipes-slider-outer-main').slick({
  accessibility: false,
  arrows:true,
  dots:false,
  rows:2,
  slidesToShow:2,
  slidesToScroll:1,
  infinite:false,
  adaptiveHeight:false,
  prevArrow: prev_icon,
  nextArrow: next_icon,
  cssEase: 'ease',
  responsive: [
    {
      breakpoint: 1080,
      settings: {
        slidesToShow:2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow:1,
      }
    }
  ]
});


/*########## Trade Info Page Download Content Zip #############*/

function downloadZip(name,urls){
  var zip = new JSZip();
  // var img = zip.folder("images");
  var count = 0;
  var zipFilename = name+".zip";
  var counter=1;
  urls.forEach(function(url){
    // loading a file and add it in a zip file
    JSZipUtils.getBinaryContent(url.path, function (err, data) {
      if(err) {
        throw err; // or handle the error
      }
      var file=zip.file(url.name+'_'+counter+'.'+url.ext, data, {binary:true});

      ++count;
		counter++;
      if (count == urls.length) {
        zip.generateAsync({type:"blob"})
        .then(function(blob) {
          saveAs(blob, name+".zip");
        });
      }
    });
  });
}

$('.cat_down_low_res').click(function(){
  var urls = [];
  var _Name = $(this).parent().siblings('.bod-heading').text()+' low';
  var _imagearea= $(this).closest('.category-content').find('.employee-details');
  _imagearea.find('a.down_low_res').each(function(){
    var url = [];
    url['path']=$(this).data('href');
    url['name']=$(this).attr('download');
    url['ext']=$(this).data('ext');
    urls.push(url);
  })
  downloadZip(_Name,urls)
})


$('.cat_down_high_res').click(function(){
  var urls = [];
  var _Name = $(this).parent().siblings('.bod-heading').text()+' High';
  var _imagearea= $(this).closest('.category-content').find('.employee-details');
  _imagearea.find('a.down_high_res').each(function(){
    var url = [];
    url['path']=$(this).data('href');
    url['name']=$(this).attr('download');
    url['ext']=$(this).data('ext');
    urls.push(url);
  })
  downloadZip(_Name,urls)
})


function downloadAllZip(res){
  var zip = new JSZip();
  var countf = 0;
  var count = 0;
  var _selector='a.down_high_res';
  var _zipName='All Assets High.zip';
  if(res == 'low'){
    _selector='a.down_low_res';
    _zipName='All Assets Low.zip';
  }
  var allImages = $(_selector).length;
  $('.category-content').each(function(cat){

    if($(this).find(_selector).length > 0){

      var _imgSelect = $(this).find(_selector);
      var _folderName=	$(this).find('.bod-heading').text();
      var _folder = zip.folder(_folderName);
      var counter = 1;
      _imgSelect.each(function(img){
        var _url = $(this).data('href');
        var _name = $(this).attr('download');
        var _ext = $(this).data('ext');
        JSZipUtils.getBinaryContent(_url, function (err, data) {
          if(err) {
            throw err; // or handle the error
          }
          _folder.file(_name+'_'+counter+'.'+_ext, data, {binary:true});

          ++count;
			counter++;
          if (count == allImages ) {
            zip.generateAsync({type:"blob"})
            .then(function(blob) {
              saveAs(blob, _zipName);
            });
          }
        });
      })
    }
  })
}


$('.all_down_low_res').click(function(){
  downloadAllZip('low')
})


$('.all_down_high_res').click(function(){
  downloadAllZip('high')
})


$(document).ready(function(){
  $('body').on('click','.recipe_main_article',function(){
    var url = $(this).find('a').attr('href');
    window.location.href=url;
  })
});


function isOnScreen(elem) {
  // if the element doesn't exist, abort
  if( elem.length == 0 ) {
    return;
  }
  var $window = $(window);
  var viewport_top = $window.scrollTop();
  var viewport_height = $window.height();
  var viewport_bottom = viewport_top + viewport_height;
  var $elem = $(elem);
  var top = $elem.offset().top;
  var height = $elem.height();
  var bottom = top + height;

  return (top >= viewport_top && top < viewport_bottom) ||
    (bottom > viewport_top && bottom <= viewport_bottom) ||
    (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

function headingFill(){
  var _vt =$(window).scrollTop();
  var _vh = $(window).height();
  var _vb =_vt+_vh;
  $('.background-heading').each(function(){
    var _bt = $(this).offset().top;
    if(_bt < _vb-220) {
      $(this).addClass('active');
    }
    else{
      $(this).removeClass('active');
    }
  });
}


$(document).ready(function(){
  $('.faq-item').click(function(){
    const button = $(this).find('> .faq-question button')
    const answer = $(this).find('> .faq-answer')

    if($(this).hasClass('open')){
      $(this).removeClass('open');
      if (answer) answer.slideUp(100);
      if (button) button.attr('aria-expanded', 'false');
    }else{
      $('.faq-item').removeClass('open');
      $('.faq-item button').attr('aria-expanded', 'false');
      $('.faq-answer').slideUp(100);
      $(this).addClass('open');
      if (answer) answer.slideDown(500);
      if (button) button.attr('aria-expanded', 'true');
    }
  })
})

var _count = 0;
var __wtop=$(window).scrollTop();

window.addEventListener('scroll', function(e) {

  if(isOnScreen($('.about-section-four'))) {
  	$('.about-section-four').addClass('active');
  }else{
  	$('.about-section-four').removeClass('active');
  }
  if(isOnScreen($('.discover_main_section'))) {
  	$('.discover_main_section').addClass('active');
  }else{
  	$('.discover_main_section').removeClass('active');
  }
  $('.shapes1').each(function(){
    if(isOnScreen($(this))) {
      var final = $(this).height()+250;
      var _top = $(this).offset().top;
      var _winbot = $(window).scrollTop()+$(window).height();
      //       var height = parseInt($(this).siblings('.shapes2').height());
      var height = _winbot - _top;
      if(height <= final){
        if (_winbot > _top){
          $(this).siblings('.shapes2').css('height',height-200)
        } else {
          $(this).siblings('.shapes2').css('height',0)
        }
      }
    }
  });

  $('.as-shapes1').each(function(){
    if(isOnScreen($(this))) {
      var final = $(this).height();
      var _top = $(this).offset().top;
      var _winbot = $(window).scrollTop()+$(window).height();
      //       var height = parseInt($(this).siblings('.shapes2').height());
      var height = _winbot - _top ;
      var __newwtop=$(window).scrollTop();

      $(this).siblings('.as-shapes2').css('width',height - _count);

//         console.log(_count)
      if (__newwtop < __wtop){
//         console.log('up')
        _count = _count + 0.8;
      }else{
//         console.log('down')
        _count = _count + 0.8;
      }
    }else{
    	_count = 0;
    }


      __wtop = __newwtop;
  });

  headingFill();

});

// $(document).ready(function(){
//   if($('body').hasClass('template-index')){
//     headingFill();
//     if(isOnScreen($('.discover_main_section'))) {
//       $('.discover_main_section').addClass('active');
//     }else{
//       $('.discover_main_section').removeClass('active');
//     }

//     var dtop = $('.discover_section_with_shapes').offset().top;

//     var ptop = $('.product-outer-shape').offset().top;

//     var rtop = $('.recipes-outer-shape').offset().top;

//     var mtop =$('.map-section-shape').offset().top;

//     var _winbot1 = $(window).scrollTop()+$(window).height();

//     var dheight = _winbot1 - dtop;
//     var pheight = _winbot1 - ptop;
//     var rheight = _winbot1 - rtop;
//     var mheight = _winbot1 - mtop;

//     if(isOnScreen($('.discover_section_with_shapes'))){
//       $('.discover_section_with_shapes.shapes2').css('height',dheight-200);
//     }
//     if(isOnScreen($('.product-outer-shape'))){
//       $('.discover_section_with_shapes.shapes2').css('height','auto');
//       $('.product-outer-shape.shapes2').css('height',pheight-200);
//     }
//     if(isOnScreen($('.recipes-outer-shape'))){
//       $('.discover_section_with_shapes.shapes2').css('height','auto');
//       $('.product-outer-shape.shapes2').css('height','auto');
//       $('.recipes-outer-shape.shapes2').css('height',rheight-200);
//     }
//     if(isOnScreen($('.map-section-shape'))){
//       $('.discover_section_with_shapes.shapes2').css('height','auto');
//       $('.product-outer-shape.shapes2').css('height','auto');
//       $('.recipes-outer-shape.shapes2').css('height','auto');
//       $('.map-section-shape.shapes2').css('height',mheight-200);
//     }
//   }
//   else if($('body').hasClass('pages-about-us')){
//     if(isOnScreen($('.about-section-four'))) {
//       $('.about-section-four').addClass('active');
//     }else{
//       $('.about-section-four').removeClass('active');
//     }
//   }
// })

$(document).ready(function(){
if($('body').hasClass('pages-about-us')){
  $(window).on('scroll', function(e) {
    showLeaf();
  });
}
})

if($('body').hasClass('pages-about-us')){
  showLeaf();
}

function showLeaf(){
  var _winbott = Math.round($(window).height()/39);
  var _window = $(window).scrollTop();
  var _window1 = $(window).scrollTop();

  var $svg = $('.as-three-shape > svg');
  if (!$svg.length) return;

  if(isOnScreen($svg)) {
    var _data = $svg.children('svg.as-path');
    var _top = $svg.offset().top;
    var height = _winbott - _top;
    var _newWindow = _window1;

    _data.each(function(index){
      if(_top <= _newWindow+_winbott && _top >= _newWindow+10 ){
        $('svg.as-path').removeClass('active');
        $(this).addClass('active');
      }
      _newWindow = _newWindow + _winbott;
    });
  }
  else{
    var $shape = $('.as-three-shape');
    if (!$shape.length) return;

    var _w1 = $(window).scrollTop()+$(window).height();
    var _s1 = $shape.offset().top;

    if(_s1 > _w1){
      $('svg.as-path-0').addClass('active');
    }else{
      $('svg.as-path-37').addClass('active');
    }
  }
}

$(document).ready(function(){
  if($(window).width() > 749 ){
    $('.as-tool-head > .js-tooltip-button').on('mouseover',function(){
      $(this).siblings('.tool-tip').show();
    }).on('mouseleave',function(){
      $(this).siblings('.tool-tip').hide();
    }).on('keydown',function(e){
      if (e.keyCode === 13) {
        if ($(this).hasClass('activate')) {
          $(this).attr('aria-label', 'Open tooltip').attr('aria-expanded', 'false').siblings('.tool-tip').hide();
        } else {
          $(this).attr('aria-label', 'Close tooltip').attr('aria-expanded', 'true').siblings('.tool-tip').show();
        }
        $(this).toggleClass('activate');
      }
    }).on('focusout',function(){
      $(this).removeClass('activate').attr('aria-expanded', 'false').siblings('.tool-tip').hide();
    })
  }
  else{
    $('.as-tool-head > .js-tooltip-button').on('click keydown',function(e){
      if (!e.keyCode || e.keyCode === 13) {
        let _show = $(this).parent().data('block');
        $('.tool-head-mobile .tool-content').hide();
        if ($(this).hasClass('activate') && $(_show)[1]) {
          $(_show)[1].style.display = 'none';
          $(this).attr('aria-label', 'Open tooltip').attr('aria-expanded', 'false')
        } else if ($(_show)[1]) {
          $(_show)[1].style.display = 'block';
          $(this).attr('aria-label', 'Close tooltip').attr('aria-expanded', 'true')
        }
        $(this).toggleClass('activate');
      }
    }).on('focusout',function(){
      let _show = $(this).parent().data('block');
      if ($(_show)[1]) {
        $(_show)[1].style.display = 'none';
      }
      $(this).removeClass('activate').attr('aria-label', 'Open tooltip').attr('aria-expanded', 'false');
    })
  }
});

$('div#shopify-section-community-section-2 .dine-inr, div#shopify-section-community-section-2 .spotlight_articles .sl-article,div#shopify-section-community-section-3 .cs-three-article').click(function(e){
  e.preventDefault();

  var url =  $(this).find('a.custom_click').attr('href');
//   console.log(url)
    window.open(url, '_blank');
});

$('.responsive_blog').slick({
  accessibility: false,
  arrows:true,
  dots:false,
  rows:2,
  slidesToShow:4,
  slidesToScroll:1,
  infinite:false,
  adaptiveHeight:false,
  prevArrow: prev_icon,
  nextArrow: next_icon,
  cssEase: 'ease',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        adaptiveHeight:true,
         slidesToShow:2,
       slidesToScroll:1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        rows:8,
        adaptiveHeight:true
      }
    }
  ]
});

$('.responsive_news').slick({
  accessibility: false,
  arrows:true,
  dots:false,
  slidesToShow:4,
  slidesToScroll:1,
  infinite:false,
  adaptiveHeight:false,
  prevArrow: prev_icon,
  nextArrow: next_icon,
  cssEase: 'ease',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow:2,
       slidesToScroll:1,
        adaptiveHeight:true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


//   $(".accordion_head").removeClass("active");
// $(".accordion_head").click(function() {

//   var hash_id= $(this).attr("data-id");
//   console.log(hash_id)
//   var url     = window.location.pathname;
//   const state = { 'user': 'guest' }
//   const title = ''
//   history.pushState(state, title, ""+url+""+hash_id);

//   if ($('.accordion_body').is(':visible')) {
//     $(".accordion_body").slideUp(300);
//     $(".plusminus").text('+');
//     //$(this).addClass("active");
//   }
//   if ($(this).next(".accordion_body").is(':visible')) {
//     $(this).next(".accordion_body").slideUp(300);
//     $(this).children(".plusminus").text('+');
//     $(this).removeClass("active");

//   } else {
//     $(this).next(".accordion_body").slideDown(300);
//     $(this).children(".plusminus").text('-');
//     $(".accordion_head").removeClass("active")
//     $(this).addClass("active");
//   }
// });


// Theme.liquid Script

  let triggerButton
  $('body').on('click keydown','.findInStores',function(e) {
    if (!e.keyCode || e.keyCode === 13 ) {
      triggerButton = $(this)
      var containerId = $(this).attr('data-destini-container');

      var associationId = $(this).attr('data-destini-association');
      var APO = $(this).attr('data-destini-apo');
      var WTIT = $(this).attr('data-destini-WTIT');
      destini.init(containerId);
      destini.loadWidget(associationId,APO,WTIT);
      $('#widget-modal').addClass('show').show();
      $('body').addClass('modal-open');
      if($('body').find('.modal-backdrop').length < 1){
        $('body').append('<div class="modal-backdrop fade show"></div>');
      }

      if (e.keyCode === 13) {
        setTimeout(() => {
          $('.widget-modal-close').attr('aria-label', 'Close').focus()
        }, 100)
      }
    }
  }).on('keydown', function (e) {
    if (e.keyCode === 13) {
      $(this).click();
      setTimeout(() => {
        $('.widget-modal-close').attr('aria-label', 'Close').focus()
      }, 100)
    }
  });

  $('body').on('click keydown','.widget-modal-close',function(e) {
    if (!e.keyCode || e.keyCode === 13 ) {
      $('#widget-modal').removeClass('show').hide();
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();

      if (triggerButton && e.clientX === 0 && e.clientY === 0) {
        triggerButton.focus()
      }
    }
  });

  $(document).on('click', '.klaviyo_triggers', function(e){
    e.preventDefault();
    $(".formOpens").show();
    var current_variantId =$(this).attr("variant-id");
    var current_product_id =$(this).attr("get-products");
    var current_title= $(this).attr("product-name");
    //console.log(current_variantId  +   current_product_id);
    $(".formOpens").show();
    $(".notify_titles").text(current_title);
    $(".get_variants").val(current_variantId);
    $(".get_products").val(current_product_id);

  });

  $(document).on('click', '.klaviyo-bis-close' ,function () {
    $(".formOpens").hide();
  });

   /* Terms Tab */

  var anchor = window.location.hash;//returns url hash only like: '#tab4'
  if ( anchor.length > 1 ) {
   $('#tabs-content .tabcontent[data-id="' + anchor + '"]').addClass('active');
  }
  /* form script */
  $("#forms").length && $("#forms").validate({
    rules: {email: { required: true,email: true}},
    messages : {email: {email: "Please Enter Valid Email"}},
    success: function() {
      var get_email =$(".email_form").val();
      var get_varId =$(".get_variants").val();
      var get_products=$(".get_products").val();
      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                    "email": get_email,
                }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": "$shopify:::$default:::" + get_varId
              }
            }
          }
        }
      }
      //   console.log(get_email + get_varId + get_products);
      fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/", {
        "headers": {
          "Content-Type": "application/json",
          "revision":"2023-12-15"
        },
        "body": JSON.stringify(payload),
        "method": "POST",
      })
      .then(response => {
        console.log(response);
        if(get_email === ''){
        }
        else{
          $(".success_messges").show();
          setTimeout(function(){
            $(".success_messges").hide();
            $('#email').attr('value', '');
          }, 1000);
        }
      })
      .catch(err => {
        console.error(err);
      });
    }
  });

  /* Dropdown Menu */
  $(".site-nav__childlist-grid>.site-nav__childlist-item>.site-nav__child-link--parent").on("click",function(){
    $(this).toggleClass("active");
    var btn = $(this).find('.js-dropdown-icon')
    if (btn) {
      if ($(this).hasClass('active')) {
        btn.attr('aria-expanded', true)
        btn.attr('aria-label', 'close sub-menu')
      } else {
        btn.attr('aria-expanded', false)
        btn.attr('aria-label', 'open sub-menu')
      }
    }
  });
  $('[data-has-dropdowns]').on('click', function () {
    const button = $(this).find('[data-has-dropdowns-trigger]');
    if (!button) return;
    if ($(this).hasClass('site-nav--active-dropdown')) {
      button.attr('aria-expanded', true)
      button.attr('aria-label', 'close menu')
    } else {
      button.attr('aria-expanded', false)
      button.attr('aria-label', 'open menu')
    }
  });
$('.select-prod').on('change',function(variant,selector){
  var data= $(this).find('option:selected');


  if(data.attr('data-available') =='false') {
     $(this).closest('form').find('.product-form__cart-submit-custom').attr('disabled', true);
   }
  else{
     $(this).closest('form').find('.product-form__cart-submit-custom').attr('disabled', false);
  }


});

if ( jQuery( ".quotes-sliders" ).length ) {

	$(document).ready(function() {

		$('.quotes-sliders').slick({
		  accessibility: false,
		  infinite: true,
		  slidesToShow: 4,
		  slidesToScroll: 1,
		  dots:false,
		  arrows:true,
		  centerMode: true,
		  autoplay: true,
			autoplaySpeed: 500,
		  speed: 3000,
		  responsive: [
			{
			  breakpoint: 1366,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: true,
			  }
			},
			{
			  breakpoint: 991,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			  }
			},
			{
			  breakpoint: 575,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: false,
			  }
			}
		  ]
		});

	})

}

//Add the alt text
  function altxt(){
    $('.stamped-widget-poweredby > img:not([alt])').attr('alt','Stamped-io');
  }
//Event listner
  function addEventListenerStamped(el,eventName,handler) {
   if (el.addEventListener) { el.addEventListener(eventName, handler); }
   else { el.attachEvent('on' + eventName, function () { handler.call(el); }); }
}

addEventListenerStamped(document,'stamped:reviews:loaded',function(e) {
  altxt();
});
  altxt();

$(document).ready(function(){
  $('.js-cart-drawer-toggle').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      type: 'GET',
      url: '/cart?view=custom',
      dataType: 'html',
      success: function (data) {
        $('.cart-drawer-body').html(data);
        $('body').addClass('cart-open');
        $('.sdz-cart-drawer > .cart-drawer').addClass('cart-slide').focus();
        var cartDrawerCount = $('[data-cart-drawer-count]').text();
        // if (parseInt(cartDrawerCount) > 1) {
        //   $('[data-cart-drawer-label]').html('Items');
        // } else {
        //   $('[data-cart-drawer-label]').html('Item');
        // }

        slate.a11y.trapFocus({
          container: document.querySelector('.sdz-cart-drawer'),
          elementToFocus: document.querySelector('.js-cart-drawer-close'),
          namespace: 'cartPopOutFocus'
        });
      }
    });
  });

  if ($('.js-cart-drawer-close')) {
    $('.js-cart-drawer-close').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $('body').removeClass('cart-open');
      $('.sdz-cart-drawer > .cart-drawer').removeClass('cart-slide');
      $.ajax({
        type: 'GET',
        url: '/cart?view=custom',
        dataType: 'html',
        success: function (data) {
          $('.cart-drawer-body').html(data);
        }
      });
    });
  }

  $(document).on('click', function(e) {
    if (!$(e.target).closest('.sdz-cart-drawer .cart-drawer').length) {
      if ($('body').hasClass('cart-open')) {
        $('body').removeClass('cart-open');
        $('.sdz-cart-drawer > .cart-drawer').removeClass('cart-slide');
      }
    }
  });
})

document.addEventListener('rebuy:cart.add', (event) => {
    var cartCount = $('[data-cart-count]');
    var cartDrawerCount = $('[data-cart-drawer-count]');

  $.ajax({
    type: 'GET',
    url: '/cart?view=custom',
    dataType: 'html',
    success: function (data) {
      $('.cart-drawer-body').html(data);
    }
  });

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      if (cart.item_count > 0) {
        if (cartCount) cartCount.html(cart.item_count);
        if (cartDrawerCount) cartDrawerCount.html(cart.item_count);
      }
    })
    .catch(function(error) {
      console.log(error);
    });
});

$(document).ready(function () {
  $(".sort_filter_section .label_sort").on("click keyup",function(e){
    if ($(this).attr('aria-expanded') === 'true') {
      $(this).attr('aria-expanded', false);
    } else {
      $(this).attr('aria-expanded', true);
    }
  });

  $(".recipes_filter_blog .desktop_part.filter_part").on('toggle', function () {
    var _this = this;
    if ($(this).hasClass('showfilter')) {
      setTimeout(function() {
        $(_this).find(".filterItem").first().find('input')[0].focus();
      });
      $('.filter_icon_section .label_filter').attr('aria-expanded', true);
    } else {
      $('.filter_icon_section .label_filter').attr('aria-expanded', false);
    }
  });

  $(".recipes_filter_blog .desktop_part.filter_part .filterItem input").on('change', function () {
    var $selectedItems = $('.recipes_filter_blog .desktop_part.filter_part .filterItem input:checked');
    var ids = ['FilterLabelText'];
    $selectedItems.length && $selectedItems.each(function (index, selectedItem) {
      ids.push(selectedItem.closest('.filterItem').id);
    });
    $('.desktop_sec .label_filter').attr('aria-labelledby', ids.join(' '));
  });
  $('body').on('keydown', function (e) {
    const isEscape = e.keyCode === 27;
    const isUpArrow = e.keyCode === 38;
    const isDownArrow = e.keyCode === 40;
    if ($('.recipes_filter_blog .desktop_part.filter_part').hasClass('showfilter') && (isEscape || isUpArrow || isDownArrow)) {
      e.preventDefault();
      var $currentActiveItem = $('.recipes_filter_blog .desktop_part.filter_part .filterItem');
      if (isDownArrow) {
        var $nextItem = $currentActiveItem.next();
        if (!$nextItem.length) {
          $nextItem = $('.recipes_filter_blog .desktop_part.filter_part .filterItem').first();
        }
        $nextItem.find('input').focus();
      }
      if (isUpArrow) {
        var $prevItem = $currentActiveItem.prev();
        if (!$prevItem.length) {
          $prevItem = $('.recipes_filter_blog .desktop_part.filter_part .filterItem').last();
        }
        $prevItem.find('input').focus();
      }
      if (isEscape) {
        $('.recipes_filter_blog .desktop_part.filter_part').removeClass('showfilter');
        $(".recipes_filter_blog .desktop_part").trigger('toggle');
      }
    }
  });
});

/**
 * After Octane quiz completes, hide "Out of stock" buttons and price,
 * then append a "Find in Store" button using the product barcode from Shopify product JSON.
 */
document.addEventListener('octane.quiz.completed', () => {
  document.querySelectorAll('[data-element="oct-quiz-resultitem"]').forEach(async (item) => {

    const button = item.querySelector('button');
    if (!button) return;

    const text = (button.textContent || '').trim().toLowerCase();

    /* hide only Out of stock button */
    if (text === 'out of stock') {
      button.style.display = 'none';

      /* hide price */
      item.querySelectorAll('div, span, p').forEach(el => {
        if ((el.textContent || '').trim() === '$0.00') {
          el.style.display = 'none';
        }
      });
    }

    /* avoid duplicate button */
    if (item.querySelector('.findInStores')) return;

    /* get product link */
    const productLink = item.querySelector('a[href*="/products/"]');
    if (!productLink) return;

    const url = new URL(productLink.href);
    const handle = url.pathname.split('/products/')[1];
    const variantId = url.searchParams.get('variant');

    let barcode = '';

    try {
      const res = await fetch(`/products/${handle}.json`);
      const data = await res.json();

      if (variantId) {
        const variant = data.product.variants.find(v => String(v.id) === variantId);
        barcode = variant?.barcode || '';
      } else {
        barcode = data.product.variants?.[0]?.barcode || '';
      }
    } catch (e) {
      console.error('Fetch product json failed', e);
    }

    /* create Find in Store button */
    const newButton = document.createElement('button');

    newButton.className = 'btn fis-btn findInStores quiz-btn';
    newButton.textContent = 'Find in Store';

    newButton.setAttribute('data-toggle', 'modal');
    newButton.setAttribute('data-target', '#widget-modal');
    newButton.setAttribute('data-destini-container', 'destinidiv');
    newButton.setAttribute('data-destini-association', 'default');
    newButton.setAttribute('data-destini-apo', barcode);

    button.parentElement.appendChild(newButton);

  });
});